import Utils from '@/common/utils/utils';
import APIAmplify from '@/amplify/api';
import Logger from '@/common/utils/Logger';
import { onChatPostUpdated, onChatPostCreated, onChatPostDeleted, onUserProjectCreated, onUserProjectDeleted } from '@/graphql/subscriptions';
import { getUserAvatarUrl, getUserById } from '@/service/userService';
import { getChatPostById } from '@/service/chatPostService';
import Constant from '@/common/constant/Constant';
import _ from 'lodash';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { lastedSendMsgId } from '@/state/atom/chatAtom';
import { reloadTicketDetailIdAtom } from '@/state/atom/panelAtom';
import I18n from '@/rI18n';

const SUBSCRIPTION_TYPE = Constant.SUBSCRIPTION_TYPE;

// list all subscription for chat post 
let subscriptionList = [];

/**
 * Find index chat thread subscription
 * @param {*} typeSubscription 
 * @param {*} chatThreadId 
 * @returns index
 */
const findIndexChatThreadSubcription = (typeSubscription, chatThreadId, panelId) => {
    let index = subscriptionList.findIndex((sub, i) => {
        return sub.chatThreadId === chatThreadId && sub.type === typeSubscription && sub.panelId == panelId;
    });
    return index === undefined || index === null ? -1 : index;
};


/**
 * Unsubscribe event chat post
 * @param {*} typeSubscription 
 * @param {*} chatThreadId 
 */
const unsubscribeEventChatPost = (typeSubscription, chatThreadId, panelId) => {
    let needShowDialogReconnect = false;
   
    // find index of subscription
    let index = findIndexChatThreadSubcription(typeSubscription, chatThreadId, panelId);

    if (index < 0) {
        return needShowDialogReconnect;
    }
  
    if (subscriptionList[index]?.subscription) {
        // unsubscribe event
      
        if ( subscriptionList[index].subscription?._state !== 'closed') {
            needShowDialogReconnect = true;
            subscriptionList[index].subscription?.unsubscribe();
        } 
        // remove item in subcription list
        subscriptionList.splice(index, 1);
    }

    return needShowDialogReconnect;
   
};


/**
 * Unsubscribe all with: event delete, update chat post
 */
export const unsubscribeAll = (panelId) => {
    if (!panelId) {
        subscriptionList.forEach(sub => {
            if (sub.subscription?._state !== 'closed') sub.subscription?.unsubscribe();
        });
        subscriptionList = [];
        return;
    }

    // let unsubscribeList = []
    subscriptionList.forEach(sub => {
        if (sub.panelId == panelId) {
            sub.subscription?.unsubscribe();
            // unsubscribeList.push(sub);
        }
    });

    subscriptionList = subscriptionList.filter(function(sub) { 
        return sub.panelId !== panelId;
    });
};


/**
 * Listen subscription event update chat post
 * @param {*} chatThreadId 
 * @param {*} allState 
 */
const onSubscriptionEventUpdateChatPost = (chatThreadId, allState) => {  
    // check empty and exists of chat thread
    // if chatThreadId empty or chatThreadSubscription exists then break;
    if (Utils.isEmptyString(chatThreadId) || !allState.panelId || (findIndexChatThreadSubcription(SUBSCRIPTION_TYPE.UPDATE, chatThreadId, allState.panelId) >= 0)) {
        return;
    }
    let subscription = APIAmplify.graphql({
        query: onChatPostUpdated,
        variables: { chatThreadId: chatThreadId },
        timeout: 10000
    }).subscribe({
        next: async (resData) => {
            let msgRes = resData.value.data.onChatPostUpdated;
            const chatPostAllList = allState.chatPostAllList;
            let index = chatPostAllList.findIndex((element, i) => {
                return element.id === msgRes.id;
            });


            const chatpost = await getChatPostById(null, msgRes.id);
            const attachFiles = Utils.convertJSONDataToObject(chatpost.attachFiles);
            allState.setSubsciptionChatPostUpdateResponse({ ...msgRes, attachFiles });

            let lastedUserSendMsgId = getRecoil(lastedSendMsgId); 
            // Hot reload ticket detail for email ticket
            if (
                allState?.ticketDetailSelected?.ticketType === Constant.TICKET_TYPE.EMAIL &&
                lastedUserSendMsgId === msgRes?.id &&
                (allState?.selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER ||
                    allState?.selectThreadId === allState?.customerThread?.id)
            ) {
                setRecoil(lastedSendMsgId, '');
                setRecoil(
                    reloadTicketDetailIdAtom,
                    `${allState?.ticketDetailSelected?.id} ${Date.now().toString()}`
                );
            }
        },
        error: err => {
            // unsubscription event update chat post
            unsubscribeEventChatPost(SUBSCRIPTION_TYPE.UPDATE, chatThreadId, allState.panelId);
        }
    });
    // push subscription to list
    subscriptionList.push({
        type: SUBSCRIPTION_TYPE.UPDATE,
        chatThreadId: chatThreadId,
        panelId: allState.panelId,
        subscription: subscription
    });
};

const validateMessageCreated = (msg) => {
    switch (msg.postType) {
        case Constant.POST_TYPE.SYSTEM_AUTO_END_LIVE_CHAT:
        case Constant.POST_TYPE.CHAT_BOT_NOT_FOUND_AGENT:
        case Constant.POST_TYPE.CHAT_BOT_CONNECTED_WITH_AGENT:
        case Constant.POST_TYPE.SUPPORT_MSG:
            return false;
        default:
            return true
    }
}


/**
 * Listen subscription event create chat post
 * @param {*} API 
 * @param {*} chatThreadId 
 * @param {*} allState 
 */
const onSubscriptionEventCreateChatPost = (API, chatThreadId, allState) => {
    
    // check empty and exists of chat thread
    // if chatThreadId empty or chatThreadSubscription exists then break;
    if (Utils.isEmptyString(chatThreadId) || !allState.panelId ||
        (findIndexChatThreadSubcription(SUBSCRIPTION_TYPE.CREATE, chatThreadId, allState.panelId) >= 0)) {
        return;
    }
    let subscription = APIAmplify.graphql({
        query: onChatPostCreated,
        variables: { chatThreadId: chatThreadId }
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onChatPostCreated;
            msgRes.subcriptionType = SUBSCRIPTION_TYPE.CREATE;
           
            if (
                msgRes.postType === Constant.POST_TYPE.TICKET_REMOVED &&
                allState?.setIsOpenModalTicketDeleted
                && msgRes.creatorId !== allState?.userDetail?.id
            ) {
                allState.setIsOpenModalTicketDeleted(true);
                return;
            };

            if(msgRes.ticketAffiliationProject && msgRes.ticketAffiliationProject !== allState?.projectInuseDetail?.id && msgRes?.deliverInfo?.status === Constant.DELIVER_STATUS.UNDELIVER){
                return;
            };

            if (
                !Utils.isEmptyObject(msgRes) &&
                ([
                    Constant.POST_TYPE.SYSTEM_AUTO_END_LIVE_CHAT,
                    Constant.POST_TYPE.ANONYMOUS_END_LIVE_CHAT,
                ].includes(msgRes.postType) ||
                    (msgRes.postType === Constant.POST_TYPE.END_LIVE_CHAT_MESSAGE &&
                        // msgRes.content is stored in the DB as the original Japanese text (SystemMessageText.CBOTMSG018).
                        // Compare against I18n.get('CBOTMSG018') to get that same original text, NOT trI18n('CBOTMSG018'):
                        // trI18n translates to the current UI language, so the comparison would fail when the UI is not Japanese.
                        msgRes.content === I18n.get('CBOTMSG018') &&
                        msgRes.creatorId !== allState?.userDetail?.id))
            ) {
                if (allState.setIsOpenModalReloadPage) {
                    allState.setIsOpenModalReloadPage(true);
                }
                return;
            }

            // is mine => do not thing. hot fix for upload 
            // if (msgRes?.clientUUId && msgRes.clientUUId === currentClientId  && msgRes.postType === Constant.POST_TYPE.IMAGE) {
            //     return;
            // } else {
                // update post msg
            if(validateMessageCreated(msgRes)){
                allState.setChatPostUpdate(msgRes);
                Logger.info('onSubscriptionEventCreateChatPost: ', msgRes);
            // }
            }
            
        },
        error: err => {
        
            console.log('onSubscriptionEventUpdateChatPost err', err)
            // unsubscription event create chat post
            unsubscribeEventChatPost(SUBSCRIPTION_TYPE.CREATE, chatThreadId, allState.panelId)
        }
    });
    // push subscription to list
    subscriptionList.push({
        type: SUBSCRIPTION_TYPE.CREATE,
        chatThreadId: chatThreadId,
        panelId: allState.panelId,
        subscription: subscription
    });
};


/**
 * Listen subscription event delete chat post
 * @param {*} API 
 * @param {*} chatThreadId 
 * @param {*} allState 
 */
const onSubscriptionEventDeleteChatPost = (API, chatThreadId, allState) => {
    
    // check empty and exists of chat thread
    // if chatThreadId empty or chatThreadSubscription exists then break;
    if (Utils.isEmptyString(chatThreadId) ||!allState.panelId ||
        (findIndexChatThreadSubcription(SUBSCRIPTION_TYPE.DELETE, chatThreadId, allState.panelId) >= 0)) {
        return;
    }
    let subscription = APIAmplify.graphql({
        query: onChatPostDeleted,
        variables: { chatThreadId: chatThreadId }
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onChatPostDeleted;
            
            getUserById(API, msgRes.creatorId).then(userDetail => {
                let userDetailPostMsg = !Utils.isEmptyObject(userDetail) ? userDetail : {};
                userDetailPostMsg.avatar = getUserAvatarUrl(userDetailPostMsg.image);
                msgRes.userDetailPostMsg = userDetailPostMsg;

                msgRes.subcriptionType = SUBSCRIPTION_TYPE.DELETE;
                allState.setChatPostUpdate(msgRes);
            });

        },
        error: err => {
            console.log('onSubscriptionEventUpdateChatPost err', err)
            // unsubscription event delete chat post
            unsubscribeEventChatPost(SUBSCRIPTION_TYPE.DELETE, chatThreadId, allState.panelId);
        }
    });
    // push subscription to list
    subscriptionList.push({
        type: SUBSCRIPTION_TYPE.DELETE,
        chatThreadId: chatThreadId,
        panelId: allState.panelId,
        subscription: subscription
    });
};

/**
 * Init subscription chat post
 * 1: Event update
 * 2: Event create
 * 3: Event delete
 * @param {*} args 
 */
export const initSubscriptionChatPost = (args) => {
    // chatThread list
    let chatThreadList = [];

    // escalationThread
    let escalationThread = [...args.chatThreadAll.escalationThread];
    chatThreadList = Utils.isEmptyArray(escalationThread) ? [] : escalationThread;

    // customerReferenceThread
    let customerReferenceThread = args.chatThreadAll.customerReferenceThread;
    chatThreadList.push(customerReferenceThread);

    // customerThread
    let customerThread = args.chatThreadAll.customerThread;
    chatThreadList.push(customerThread);

    // internalThread
    let internalThread = args.chatThreadAll.internalThread;
    chatThreadList.push(internalThread);

    // aiAssistantThread
    let aiAssistantThread = args.chatThreadAll.aiAssistantThread;
    chatThreadList.push(aiAssistantThread);

    // delegateThread
    let delegateThread = args.chatThreadAll.delegateThread;
    chatThreadList.push(delegateThread);
    // init subscription
    chatThreadList.forEach((thread) => {
        if (thread?.id) {
             // init subscription update chat post
            onSubscriptionEventUpdateChatPost(thread?.id, args);

            // init subscription create chat post
            onSubscriptionEventCreateChatPost(args.API, thread?.id, args);

            // init subscription delete chat post
            onSubscriptionEventDeleteChatPost(args.API, thread?.id, args);
        }
       
    });
};

export const initSubscriptionChatPostKnowledge = (args) => {
    // knowledgeThread
    let knowledgeThread = _.cloneDeep(args.chatThreadAll.knowledgeThread);

     // init subscription update chat post
    onSubscriptionEventUpdateChatPost(knowledgeThread?.id, args);

    // init subscription create chat post
    onSubscriptionEventCreateChatPost(args.API, knowledgeThread?.id, args);

    // init subscription delete chat post
    onSubscriptionEventDeleteChatPost(args.API, knowledgeThread?.id, args);
};

/**
 * Init subscription for mention chat, 
 * @param {*} args 
 * @param {*} projectIdListForSubscriptionMention 
 */
export const initSubscriptionMentionChat = (args, projectIdListForSubscriptionMention) => {
    if(!Utils.isEmptyArray(projectIdListForSubscriptionMention)) {
        projectIdListForSubscriptionMention.forEach((projectId) => {
            // init subscription user add to project
            onSubscriptionEventCreateUserProject(args, projectId);

            // init subscription user remove from project
            onSubscriptionEventDeleteUserProject(args, projectId);
        })
    }
}

/**
 * onSubscriptionEventCreateUserProject
 * @param {*} allState 
 * @param {*} projectId 
 */
export const onSubscriptionEventCreateUserProject = (allState, projectId) => {
    const isExists = subscriptionList.find(sub => sub?.projectId === projectId  && sub.panelId == allState.panelId && sub.type === SUBSCRIPTION_TYPE.CREATE)
    if (isExists) return;
    let subscription = APIAmplify.graphql({
        query: onUserProjectCreated,
        variables: { projectId: projectId }
    }).subscribe({
        next: resData => {
            let userProjectRes = resData.value.data.onUserProjectCreated;
            userProjectRes.subcriptionType = SUBSCRIPTION_TYPE.CREATE;
            allState.setUserProjectMentionUpdated({ ...userProjectRes });
            Logger.info('onSubscriptionEventCreateUserProject: ', userProjectRes);
        },
        error: err => {
            console.log('onSubscriptionEventUpdateChatPost err', err)
            // Logger.info('onSubscriptionEventUpdateChatPost error: ', err);
        }
    });

    // push subscription to list
    subscriptionList.push({
        type: SUBSCRIPTION_TYPE.CREATE,
        chatThreadId: '',
        panelId: allState.panelId,
        subscription: subscription,
        projectId: projectId
    });
}

export const onSubscriptionEventDeleteUserProject = (allState, projectId) => {
    const isExists = subscriptionList.find(sub => sub?.projectId === projectId && sub.panelId == allState.panelId && sub.type === SUBSCRIPTION_TYPE.DELETE)
    if (isExists) return;

    let subscription = APIAmplify.graphql({
        query: onUserProjectDeleted,
        variables: { projectId: projectId }
    }).subscribe({
        next: resData => {
            let userProjectDel = resData.value.data.onUserProjectDeleted;
            userProjectDel.subcriptionType = SUBSCRIPTION_TYPE.DELETE;
            allState.setUserProjectMentionUpdated({ ...userProjectDel });
        },
        error: err => {
            console.log('onSubscriptionEventDeleteUserProject err', err)
            // Logger.info('onSubscriptionEventDeleteUserProject error: ', err);
        }
    });

    // push subscription to list
    subscriptionList.push({
        type: SUBSCRIPTION_TYPE.DELETE,
        chatThreadId: '',
        panelId: allState.panelId,
        subscription: subscription,
        projectId: projectId
    });
}
